export type IntegrationHealthStatus = 'healthy' | 'failed' | 'disabled';

export interface IntegrationHealthItem {
    providerId: number;
    providerName: string;
    status: IntegrationHealthStatus;
    lastSyncUtc: string | null;
    lastAttemptUtc: string | null;
    message: string | null;
}

export const INTEGRATION_HEALTH_POLL_MS = 60 * 1000;
export const INTEGRATION_NETWORK_UNREACHABLE_MESSAGE =
    'Could not reach the remote service. Check your network connection.';

export function shouldPollIntegrationHealth(items: IntegrationHealthItem[]): boolean {
    return items.some(item => item.status === 'healthy' || item.status === 'failed');
}

export function overlayIntegrationHealthWhenOffline(
    items: IntegrationHealthItem[],
    isOnline: boolean
): IntegrationHealthItem[] {
    if (isOnline)
        return items;

    return items.map(item => {
        if (item.status === 'disabled')
            return item;

        return {
            ...item,
            status: 'failed' as IntegrationHealthStatus,
            message: INTEGRATION_NETWORK_UNREACHABLE_MESSAGE
        };
    });
}
